import { render, staticRenderFns } from "./PacsEventsFrame.vue?vue&type=template&id=c09f9698"
import script from "./PacsEventsFrame.vue?vue&type=script&lang=js"
export * from "./PacsEventsFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports